import { AtlasMenuContentItem, Button, Menu } from "@resource/atlas";
import { useMemo } from "react";
import useAnalytics from "react-hooks/useAnalytics";

import { FilterTimeRangeEnum } from "./SortBar/SortBar";

type FeedbackTimeRangeFilterProps = {
  timeRange: FilterTimeRangeEnum;
  setFilter(filter: FilterTimeRangeEnum): void;
  className?: string;
};

function FeedbackTimeRangeFilter({
  timeRange,
  setFilter,
  className,
}: FeedbackTimeRangeFilterProps) {
  const analytics = useAnalytics();

  return (
    <Menu.Root>
      <Menu.Trigger>
        <Button isGhost isDropdown className={className}>
          {timeRange}
        </Button>
      </Menu.Trigger>
      <Menu.Content
        defaultSize="compact"
        items={useMemo(
          () =>
            [
              FilterTimeRangeEnum.last1Month,
              FilterTimeRangeEnum.last3Months,
              FilterTimeRangeEnum.last6Months,
              FilterTimeRangeEnum.lastYear,
            ].map(
              (range): AtlasMenuContentItem => ({
                _type: "item",
                children: range,
                key: range,
                isSelectable: true,
                isSelected: timeRange === range,
                onSelect: () => {
                  analytics.track(
                    "Candidate Feedback Table - Time Range Changed",
                    { target: range, previousValue: timeRange }
                  );
                  setFilter(range);
                },
              })
            ),
          [analytics, setFilter, timeRange]
        )}
      />
    </Menu.Root>
  );
}

export default FeedbackTimeRangeFilter;
